import React from 'react'
import { Spinner } from './styles'

function Loader() {
    return <Spinner />
}

export default Loader